/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Offcanvas } from 'react-bootstrap';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faBarcode } from '@fortawesome/free-solid-svg-icons';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import AccordionCreateFilter from './AccordionCreateFilter';
import { useWindowWidth } from 'utils/useWindowSize';

interface AccordingToProductFilterProps {
  setGeneratedTableData?: any;
  savedValues?: any;
  setSavedValues?: any;
  setGetName?: any;
  setGetBarcode?: any;
}

const AccordingToProductFilter = ({
  setGeneratedTableData,
  savedValues,
  setSavedValues,
  setGetName,
  setGetBarcode
}: AccordingToProductFilterProps) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const windowSize: any = useWindowWidth();

  return (
    <div>
      <Form
        className={
          windowSize > 768 ? 'd-flex gap-3' : 'd-flex flex-column gap-3'
        }
      >
        <div className="d-flex gap-2">
          <div className="form-icon-container">
            <Form.Floating>
              <Form.Control
                type="text"
                placeholder={t('enter_product')}
                onFocus={e => e.target.select()}
                onChange={e => setGetName(e.target.value)}
                className="form-icon-input"
              />
              <label
                htmlFor="floatingInputCustom"
                className="form-icon-label text-700"
              >
                {t('enter_product')}
              </label>
            </Form.Floating>
            <FontAwesomeIcon
              icon={faSearch}
              className="text-900 fs-9 form-icon"
            />
          </div>

          <div className="form-icon-container">
            <Form.Floating>
              <Form.Control
                type="text"
                placeholder={t('scan_barcode')}
                onFocus={e => e.target.select()}
                onChange={e => setGetBarcode(e.target.value)}
                className="form-icon-input"
              />
              <label
                htmlFor="floatingInputCustom"
                className="form-icon-label text-700"
              >
                {t('scan_barcode')}
              </label>
            </Form.Floating>
            <FontAwesomeIcon
              icon={faBarcode}
              className="text-900 fs-9 form-icon"
            />
          </div>
        </div>

        <div className="d-flex gap-2">
          <Button
            style={{ height: '48px' }}
            variant="outline-primary"
            onClick={() => setOpenModal(true)}
          >
            <FeatherIcon icon="filter" className="me-2" size={20} />
            {t('filter')}
          </Button>

          <Button style={{ height: '48px' }} variant="outline-primary">
            <FeatherIcon icon="upload-cloud" className="me-2" size={20} />
            {t('export')}
          </Button>
        </div>
        <Offcanvas
          show={openModal}
          onHide={() => {
            setOpenModal(false);
          }}
          placement="end"
          backdrop="static"
          keyboard={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title style={{ fontSize: '24px', fontWeight: '600' }}>
              {t('filter')}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <AccordionCreateFilter
              setGeneratedTableData={setGeneratedTableData}
              savedValues={savedValues}
              setSavedValues={setSavedValues}
              setOpenModal={setOpenModal}
            />
          </Offcanvas.Body>
        </Offcanvas>
      </Form>
    </div>
  );
};

export default AccordingToProductFilter;
